
export const getUserProfil = () => {
  return JSON.parse(localStorage.getItem("infoUser"));
};

export const getUserMenu = () => {
  return JSON.parse(localStorage.getItem("menu"));
};

export const userToken = () => {
  const user = getUserProfil();
  return user ? user.accessToken : null;
};

export const saveUserProfil = (data) => {
  return localStorage.setItem("infoUser", JSON.stringify(data));
};

export const saveMenu = (menu) => {
  return localStorage.setItem("menu", JSON.stringify(menu));
};
export const HOME = "/backoffice";

export const resetStorage = () => {
  localStorage.removeItem("infoUser");
  localStorage.removeItem("menu");
  localStorage.removeItem("groupe");
  localStorage.removeItem("action");
  localStorage.removeItem("selectedMenuParent");
  localStorage.removeItem("sousMenuSelected");
};

// export const NavigateToHome = () => {
//   const user = getUserProfil();
//   const menu = getUserMenu();
//   return user?.roles[0] === "ROLE_ADMIN"
//     ? HOME +
//     menu?.sort(function (a, b) {
//       return a?.menu?.numeroOrdre - b?.menu?.numeroOrdre;
//     })[0]?.sousMenus[0]?.sousMenu?.route
//     : user?.roles[0] === "ROLE_COMMERCIALE"
//       ? HOME + "/home"
//       : HOME + menu[0]?.sousMenus[0]?.sousMenu?.route;
// };

export const NavigateToHome = () => {
  const user = getUserProfil();
  const menu = getUserMenu();

  // Vérification de la présence de l'utilisateur et de son rôle
  if (!user || !user.roles || user.roles.length === 0) {
    console.warn("Utilisateur ou rôles non définis");
    return `${HOME}/login`;
  }

  const userRole = user.roles[0];

  // Route pour les commerciaux
  if (userRole === "ROLE_COMMERCIALE") {
    return `${HOME}/home`;
  }

  // Récupération de la première route du menu
  const getFirstMenuRoute = () => {
    if (!menu || menu.length === 0) {
      console.warn("Menu non disponible");
      return "/dashboard"; // Route par défaut
    }

    // Tri du menu par numéro d'ordre pour les admins
    const sortedMenu = userRole === "ROLE_ADMIN"
      ? [...menu].sort((a, b) =>
        (a?.menu?.numeroOrdre || 0) - (b?.menu?.numeroOrdre || 0)
      )
      : menu;

    // Recherche de la première route valide
    for (const menuItem of sortedMenu) {
      if (menuItem?.sousMenus && menuItem.sousMenus.length > 0) {
        const firstSousMenu = menuItem.sousMenus[0]?.sousMenu;
        if (firstSousMenu?.route) {
          return firstSousMenu.route;
        }
      }
    }

    console.warn("Aucune route trouvée dans le menu");
    return "/dashboard"; // Route par défaut
  };

  const route = getFirstMenuRoute();
  return `${HOME}${route}`;
};

export const saveToken = (token) => {
  return localStorage.setItem("accessToken", JSON.stringify(token));
};

export const isLoggedIn = () => {
  return getUserProfil() ? true : false;
};

export const months = [
  { code: 1, name: "Janvier" },
  { code: 2, name: "Février" },
  { code: 3, name: "Mars" },
  { code: 4, name: "Avril" },
  { code: 5, name: "Mai" },
  { code: 6, name: "Juin" },
  { code: 7, name: "Juillet" },
  { code: 8, name: "Août" },
  { code: 9, name: "Septembre" },
  { code: 10, name: "Octobre" },
  { code: 11, name: "Novembre" },
  { code: 12, name: "Décembre" },
];

export const years = [
  { name: "2027" },
  { name: "2026" },
  { name: "2025" },
  { name: "2024" },
  { name: "2023" },
  { name: "2022" },
];

export const checkTagValidity = (tag) => {
  const listeTags = localStorage.getItem("action")
    ? JSON.parse(localStorage.getItem("action"))
    : [];
  const isPresent = listeTags.some((element) => element.tag === tag);

  return isPresent;
};

export const options = {
  responsive: true,
  stacked: false,
  plugins: {
    title: {
      display: false,
    },
  },
  scales: {
    y: {
      type: "linear",
      display: true,
      position: "left",
      grid: {
        display: false,
      },
    },
  },
};
